import React from "react";
import Table from "@mui/material/Table";
import { DtvCompetitorComparisonTableHead } from "./dtv-competitor-comparison-table-head";
import { DtvCompetitorComparisonTableBody } from "./dtv-competitor-comparison-table-body";
import { formatAria, isIcon, renderValue } from "./dtv-competitor-comparison-table-types";

export function renderComparisonTable({
  featureColWidth,
  dtvColWidth,
  competitorColWidth,
  mainPackageLogo,
  mainPackageLabel,
  mainPackages,
  tooltip,
  aria,
  competitorsMap,
  competitorKeysArr,
  competitorKey,
  mainPkgKey,
  featuresArr,
  mainPkgDetails,
  competitorDetailsObj,
  isGenrePack,
  selectOpen,
  setSelectOpen,
  mainSelectOpen,
  setMainSelectOpen,
  handleCompetitorChange,
  handleMainPackageChange,
  activeTab,
  setActiveTab,
  selectRef,
  selectInputRef,
  menuWidth,
  tableKey
}: any) {
  return (
    <Table
      key={tableKey || `table-${mainPkgKey}`}
      aria-label={formatAria(aria?.tableLabel, {
        dtv: mainPackageLabel,
        competitor: competitorKey
      })}
      sx={{
        width: "100%",
        background: "transparent",
        borderCollapse: "separate",
        borderSpacing: 0,
        tableLayout: "fixed",
        borderColor: "#D1D1D1",
        marginTop: !isGenrePack ? 2 : 0
      }}
    >
      <DtvCompetitorComparisonTableHead
        activeTab={activeTab}
        aria={aria}
        competitorColWidth={competitorColWidth}
        competitorKeys={competitorKeysArr}
        competitors={competitorsMap}
        dtvColWidth={dtvColWidth}
        featureColWidth={featureColWidth}
        handleCompetitorChange={handleCompetitorChange}
        handleMainPackageChange={handleMainPackageChange}
        isGenrePack={isGenrePack}
        mainPackageLabel={mainPackageLabel}
        mainPackageLogo={mainPackageLogo}
        mainPackages={mainPackages}
        mainSelectOpen={mainSelectOpen}
        menuWidth={menuWidth}
        selectInputRef={selectInputRef}
        selectOpen={selectOpen}
        selectRef={selectRef}
        selectedCompetitor={competitorKey}
        selectedMainPackage={mainPkgKey}
        setActiveTab={setActiveTab}
        setMainSelectOpen={setMainSelectOpen}
        setSelectOpen={setSelectOpen}
        tooltip={tooltip}
      />
      <DtvCompetitorComparisonTableBody
        aria={aria}
        competitorColWidth={competitorColWidth}
        competitorDetails={competitorDetailsObj}
        dtvColWidth={dtvColWidth}
        featureColWidth={featureColWidth}
        features={featuresArr}
        formatAria={formatAria}
        isGenrePack={isGenrePack}
        isIcon={isIcon}
        mainPackageDetails={mainPkgDetails}
        renderValue={renderValue}
      />
    </Table>
  );
}
